<template>
  <div>
    <div class="query-select">
      <el-form ref="queryForm" :model="queryForm" :inline="true">
        <el-form-item label="题干">
          <el-input
            v-model.trim="queryForm.questionStem"
            placeholder="请输入题干"
          ></el-input>
        </el-form-item>
        <el-form-item label="题型">
          <el-select
            clearable
            @change="getTableInfo"
            v-model="queryForm.questionType"
            placeholder="请搜索题型"
          >
            <el-option
              v-for="item in practicalQuestionTypes"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期" class="mr-left">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="请搜索创建日期"
            end-placeholder="请搜索创建日期"
            value-format="yyyy-MM-dd"
            @change="getTableInfo"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button
          plain
          round
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getTableInfo"
          >查询</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="warning"
          icon="el-icon-refresh-left"
          @click="reset"
          >重置</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="success"
          icon="el-icon-plus"

          @click="openForm('create')"
          >新增</el-button
        >
      </div>
    </div>
    <div class="main-table">
      <el-table
        :data="tableData"
        style="width: 85vw"
        stripe
        size="small"
        v-loading="loading"
        header-cell-class-name="table-header"
      >
        <el-table-column align="center" type="index" width="50">
        </el-table-column>
        <el-table-column
          align="center"
          prop="questionStem"
          label="题干"
          width="500"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="questionType"
          label="题型"
          min-width="120"
        >
          <template slot-scope="scope">
            <dict-tag type="practical_type" :value="scope.row.questionType" />
          </template>
        </el-table-column>

        <el-table-column
          width="360"
          header-align="center"
          align="center"
          prop="url"
          label="题目资源"
        >
          <template slot-scope="scope">
            <FileDetail :data="scope.row" size="100" is-table></FileDetail>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="createTime" label="创建日期">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.createTime, "YYYY-MM-DD") }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="300">
          <template slot-scope="scope">
            <el-button
              plain
              round
              size="small"
              type="warning"
              @click="openForm('edit', scope.row.questionsId)"
              >编辑</el-button
            >

            <el-button
              plain
              round
              size="small"
              type="danger"
              @click="removeClick(scope.row.questionsId)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="10"
        layout="total, prev, pager, next"
        :current-page.async="queryForm.pageNum"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <PracticalForm ref="formRef" @success="getTableInfo"></PracticalForm>
  </div>
</template>

<script>
import { formatDateTime } from "@/utils/util.js";
import { getList, deleteInfo } from "@/api/questionBank/practical";
import { getDictOptions } from "@/utils/dict.js";
import PracticalForm from "./PracticalForm.vue";
import FileDetail from "@/components/FileDetail.vue";
export default {
  name: "PracticalBank",
  components: { PracticalForm, FileDetail },
  data() {
    return {
      loading: false,
      tableData: [],
      totalCount: 0,
      dateRange: null,
      queryForm: {
        pageNum: 1,
        pageSize: 10
      }
    };
  },
  computed: {
    practicalQuestionTypes() {
      return getDictOptions("practical_type");
    }
  },
  methods: {
    formatDateTime,
    openForm(type, id = null) {
      this.$refs.formRef.open(type, id, this.$route.query.id);
    },
    reset() {
      this.queryForm = {
        pageNum: 1,
        pageSize: 10
      };
      this.dateRange = null;
      this.getTableInfo();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNum = val;
      this.getTableInfo();
    },
    async getTableInfo() {
      let obj = {};
      if (this.dateRange) {
        obj = {
          startTime: this.dateRange[0] + " 00:00:00",
          endTime: this.dateRange[1] + " 23:59:59"
        };
      }
      const res = await getList({
        ...this.queryForm,
        ...obj,
        questionBankId: this.$route.query.id
      });
      console.log(res);
      this.tableData = res.data.rows;
      this.totalCount = res.data.total;
    },
    async removeClick(id) {
      this.$confirm("此操作将删除该题目,是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const res = await deleteInfo(id);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.getTableInfo();
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.getTableInfo();
  }
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/views/QuestionBank/practical/index.vue